import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils';
import { TermsPage } from '@/views/TermsPage';
export default function Terms() {
  return <TermsPage data-sentry-element="TermsPage" data-sentry-component="Terms" data-sentry-source-file="index.page.tsx" />;
}
export const getStaticProps = getDefaultStaticProps;
Terms.getLayout = getEmptyLayout;